import React from "react";
import { useTranslation } from "react-i18next";
import SEO from "components/SEO";
import DynamicAnalyse from "pages/DynamicAnalyse";
import LandlordSolutionHeaderAnalyse from "./LandlordSolutionHeaderAnalyse";
import LandlordSolutionSectionFive from "./LandlordSolutionSectionFive";
import LandlordSolutionSectionFour from "./LandlordSolutionSectionFour";
import LandlordSolutionSectionThree from "./LandlordSolutionSectionThree";
import LandlordSolutionSectionTwo from "./LandlordSolutionSectionTwo";

const SolutionPage = () => {
  const { t } = useTranslation("solutionLandlord");
  return (
    <>
      <SEO title={t("meta.title")} description={t("meta.description")} />
      <LandlordSolutionHeaderAnalyse />
      <LandlordSolutionSectionTwo />
      <LandlordSolutionSectionThree />
      <LandlordSolutionSectionFour />
      <LandlordSolutionSectionFive />
      <DynamicAnalyse page="landlord" />
    </>
  );
};

export default SolutionPage;
